module.exports = __webpack_public_path__ + "static/media/34-4.ab065f0e.mp3";